import { render, staticRenderFns } from "./reporteHistorialAgente.vue?vue&type=template&id=b84095ca&"
import script from "./reporteHistorialAgente.vue?vue&type=script&lang=js&"
export * from "./reporteHistorialAgente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports